import { render } from "./SwiftPlusBalanceBlock.vue?vue&type=template&id=9bed2de4&scoped=true"
import script from "./SwiftPlusBalanceBlock.vue?vue&type=script&lang=js"
export * from "./SwiftPlusBalanceBlock.vue?vue&type=script&lang=js"

import "./SwiftPlusBalanceBlock.vue?vue&type=style&index=0&id=9bed2de4&scoped=true&lang=scss"

import exportComponent from "/builds/swift-dental/my-swift-dental/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9bed2de4"]])

export default __exports__